import { Card, Col, List, Row, Table } from "antd";
import { useMediaQuery } from "react-responsive";
import { useHistory } from "react-router-dom";
import FormBar from "./formbar.layout";
import PaginationLayout from "./pagination.layout";
type Props = {
  defaultPageSize?: any;
  loading: boolean;
  dataSource: any[];
  columns: any[];
  title?: any;
  current?: any;
  skip?: any;
  take?: any;
  total?: any;
  type?: string;
  header?: (values: string) => void;
  onChange?: (values: string, val: any) => void;
  buttonEvt?: () => void;
  filterFormSubmit?: any;
  pagination?: any;
  maxWidth?: any;
  formData?: any;
  filters?: any;
  branches?: any;
  downloadFilterData?: any;
  defaultCurrentPage?: any;
  offsetHeight?: number;
  // defaultCurrentPage?: any
  pageType?: any;
  showTotal?: any;
  rowSelection?: any;
  onShowSizeChange?: any;
  showSizeChangerFlag?: any;
  onChangeTable?: any;
  paginationPosition?: string;
};

function TableLayout({
  defaultPageSize,
  showTotal = false,
  loading,
  dataSource,
  buttonEvt,
  columns,
  onChange = () => {},
  total,
  maxWidth,
  pagination,
  formData = {} as any,
  defaultCurrentPage,
  offsetHeight = 230,
  rowSelection,
  showSizeChangerFlag,
  onChangeTable = () => {},
  paginationPosition = "bottom",
}: Props) {
  // function TableLayout({filters,pageType, loading, title, dataSource, buttonEvt, filterFormSubmit, columns,onChange,total,skip,current,maxWidth, pagination, type = 'transactionfilter', formData= {} as any, branches, downloadFilterData,defaultCurrentPage }: Props) {
  const history = useHistory();
  const screenType = {
    desktop: useMediaQuery({ minWidth: 992 }),
    tablet: useMediaQuery({ minWidth: 768, maxWidth: 991 }),
    mobile: useMediaQuery({ maxWidth: 767 }),
  };
  return (
    <div>
      {!screenType.mobile && (
        <Table
          className="crm-table"
          rowSelection={rowSelection}
          title={() => {
            return formData.formElements ? (
              <Row align={"middle"}>
                <Col
                  span={paginationPosition == "bottom" ? 24 : 14}
                  className="filters-formbar"
                >
                  <FormBar
                    name={"generic_filters"}
                    onClicks={buttonEvt}
                    onFinish={formData.onFinish}
                    onFinishFailed={formData.onFinishFailed}
                    formElements={formData.formElements}
                    initialValues={formData.initialValues}
                    onValuesChange={formData.onValuesChange}
                    buttonText={""}
                    setValues={formData.setValues ? formData.setValues : null}
                  ></FormBar>
                </Col>
                {total > 0 && pagination && paginationPosition == "top" && (
                  <Col span={10} className="text-right">
                    {total > 0 && pagination && (
                      <PaginationLayout
                        defaultCurrent={defaultCurrentPage}
                        total={total}
                        onChange={(value: any, val: any) =>
                          onChange(value, val)
                        }
                        showTotal={showTotal}
                        onShowSizeChange={false}
                        defaultPageSize={defaultPageSize}
                        showSizeChangerFlag={showSizeChangerFlag}
                      ></PaginationLayout>
                    )}
                  </Col>
                )}
              </Row>
            ) : (
              <></>
            );
          }}
          pagination={pagination}
          loading={loading}
          scroll={{ x: maxWidth, y: "calc(100vh - " + offsetHeight + "px)" }}
          //  scroll={ pageType === 'withTab' ? { x: maxWidth,y: 'calc(100vh - 230px)'} : { x: maxWidth,y: 'calc(100vh - 160px)'}}
          dataSource={dataSource}
          columns={columns}
          onChange={onChangeTable}
        />
      )}
      {screenType.mobile && (
        <>
          <Row align={"middle"}>
            <Col
              span={paginationPosition == "bottom" ? 24 : 14}
              className="filters-formbar"
            >
              <FormBar
                name={"generic_filters"}
                onClicks={buttonEvt}
                onFinish={formData.onFinish}
                onFinishFailed={formData.onFinishFailed}
                formElements={formData.formElements}
                initialValues={formData.initialValues}
                onValuesChange={formData.onValuesChange}
                buttonText={""}
                setValues={formData.setValues ? formData.setValues : null}
              ></FormBar>
            </Col>
            {total > 0 && pagination && paginationPosition == "top" && (
              <Col span={10} className="text-right">
                {total > 0 && pagination && (
                  <PaginationLayout
                    defaultCurrent={defaultCurrentPage}
                    total={total}
                    onChange={(value: any, val: any) => onChange(value, val)}
                    showTotal={showTotal}
                    onShowSizeChange={false}
                    defaultPageSize={defaultPageSize}
                    showSizeChangerFlag={showSizeChangerFlag}
                  ></PaginationLayout>
                )}
              </Col>
            )}
          </Row>
          <Row>
            <Col span={24}>
              <List
                className="app-mobile-list pb-2"
                itemLayout="vertical"
                dataSource={dataSource}
                renderItem={(item: any, index) => (
                  <List.Item key={index}>
                    <Card>
                      <Row>
                        <Col span={24}>
                          <Row>
                            <Col span={14}>{columns[0].render(item)}</Col>
                            <Col span={10}>
                              {columns[6].render(item)}
                              {/* {columns[5].render(item)} */}
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <span className="w600">
                                {columns[1].title}
                              </span>{" "}
                              : {columns[1].render(item)}
                              <br />
                              <span className="w600">
                                {columns[2].title}
                              </span>{" "}
                              : {columns[2].render(item)}
                              <br />
                              <span className="w600">
                                {columns[3].title}
                              </span>{" "}
                              : {columns[3].render(item)}
                              <br />
                              <span className="capitalize">
                                <span className="w600">{columns[4].title}</span> :{" "}
                                {item?.assigned_user ? (
                                  <>
                                    {item?.assigned_user?.first_name +
                                      " " +
                                      item?.assigned_user?.last_name}{" "}
                                    (Customer Care)
                                  </>
                                ) : (
                                  "-"
                                )}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </>
      )}
      <Row justify={"end"} className="pt-3">
        <Col className="text-right">
          {total > 0 && pagination && paginationPosition == "bottom" && (
            <PaginationLayout
              defaultCurrent={defaultCurrentPage}
              total={total}
              onChange={(value: any, val: any) => onChange(value, val)}
              showTotal={showTotal}
              onShowSizeChange={false}
              defaultPageSize={defaultPageSize}
              showSizeChangerFlag={showSizeChangerFlag}
            ></PaginationLayout>
          )}
        </Col>
      </Row>
    </div>
  );
}

export default TableLayout;
